export interface PaginationParams {
  _limit: number;
  _page: number;
  _total: number;
}

export enum Mode {
  gift,
  voucher,
}

export enum ModuleHistory {
  product,
  coupon,
  point_expired
}

export enum Status {
  success,
  error,
}

export interface ListResponse<T> {
  data: T[];
  pagination: PaginationParams;
  status: Status;
}

export interface DetailsResponse<T> {
  data: T;
}
